import { render, staticRenderFns } from "./PrbInterview.vue?vue&type=template&id=2a31db23&scoped=true&"
import script from "./PrbInterview.vue?vue&type=script&lang=js&"
export * from "./PrbInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31db23",
  null
  
)

export default component.exports